// Exports
export default {
	"videoSupportedWrapper": "videoSupportedWrapper_2HzPw",
	"preview": "preview_j3Hs4",
	"controlsWrapper": "controlsWrapper_ggLPi",
	"controls": "controls_4MRAa"
};
